import { FileUploadValidationError, getSupportedExtensions } from "./fileUploadDomain";
import { TMessage } from "../i18n/tt";

const bytesPerKB = 1024;
const bytesPerMB = bytesPerKB * 1024;
const bytesPerGB = bytesPerMB * 1024;

export function humanizeBytes(n: number) {
  if (n >= bytesPerGB) {
    return `${Math.floor(n / bytesPerGB)}GB`;
  } else if (n >= bytesPerMB) {
    return `${Math.floor(n / bytesPerMB)}MB`;
  } else if (n >= bytesPerKB) {
    return `${Math.floor(n / bytesPerKB)}KB`;
  }
  return `${n} bytes`;
}

export function createFileTypeValidationErrorMessage(error: FileUploadValidationError): TMessage {
  switch (error.type) {
    case "unsupported-files":
      return {
        key: "file-upload.unsupported-files-error",
        params: {
          filenames: { type: "list", value: error.filenames },
          supportedFileTypes: {
            type: "list",
            value: getSupportedExtensions(error.supportedFileTypes),
          },
        },
      };
    case "invalid-file":
      return { key: "file-upload.invalid-file", params: { filename: error.filename } };
    case "file-exceeds-max-dimensions":
      return {
        key: "file-upload.exceeds-max-dimensions",
        params: {
          filename: error.filename,
          width: error.maxDimensions.width,
          height: error.maxDimensions.height,
        },
      };
    case "file-exceeds-max-size":
      return {
        key: "file-upload.file-exceeds-max-size",
        params: { filename: error.filename, maxFileSize: humanizeBytes(error.maxFileSize) },
      };
  }
}
